export const getCsrfToken = () => {
  return document.cookie
    .split('; ')
    .find((row) => row.startsWith('csrf_token='))
    ?.split('=')?.[1]
}

const findString = (values, fallback = null) =>
  values.find((value) => typeof value === 'string' && value.trim()) ?? fallback

const getApiErrorData = (data) => {
  if (typeof data === 'string') {
    return { code: null, errors: [], message: data }
  }

  const nestedDetail =
    data.detail && typeof data.detail === 'object' ? data.detail : null

  return {
    message: findString(
      [
        data.message,
        typeof data.detail === 'string' ? data.detail : null,
        nestedDetail?.message,
        typeof nestedDetail?.detail === 'string' ? nestedDetail.detail : null,
      ],
      'An error occurred.',
    ),
    code: findString([data.code, nestedDetail?.code]),
    errors: Array.isArray(data.errors)
      ? data.errors
      : Array.isArray(nestedDetail?.errors)
        ? nestedDetail.errors
        : [],
  }
}

export const setHeader = (headers, name, value) => {
  if (!value) return

  if (typeof headers.set === 'function') {
    headers.set(name, value)
    return
  }

  headers[name] = value
}

export const getHeader = (headers, name) => {
  if (!headers) return undefined

  if (typeof headers.get === 'function') {
    return headers.get(name)
  }

  const headerName = Object.keys(headers).find(
    (key) => key.toLowerCase() === name.toLowerCase(),
  )

  return headerName ? headers[headerName] : undefined
}

export const getDurationMs = (metadata) => {
  if (typeof metadata?.startedAt !== 'number') return undefined
  return Math.max(0, Date.now() - metadata.startedAt)
}

export const getTelemetryProperties = (error, structuredError) => {
  const config = error.config || {}
  const metadata = config.metadata || {}
  const durationMs = getDurationMs(metadata)
  const status = structuredError.status
  const method = metadata.method || config.method
  const url = metadata.url || config.url

  return {
    url,
    method,
    status,
    message: structuredError.message,
    request_id: metadata.requestId,
    trace_id: metadata.traceparent,
    organization_id: metadata.organizationId,
    http_method: method,
    http_path: url,
    http_status: status,
    duration_ms: durationMs,
  }
}

export const normalizeApiError = (error) => {
  const fallback = {
    status: null,
    message: 'An unexpected error occurred.',
    code: null,
    errors: [],
    url: null,
    method: null,
    isNetworkError: false,
  }

  if (!error || typeof error !== 'object') return fallback

  if (error.isAxiosError) {
    const status = error.response?.status || null
    const data = error.response?.data || {}
    const url = error.config?.url || null
    const method = error.config?.method || null

    const { message, code, errors } = getApiErrorData(data)

    return {
      status,
      message,
      code,
      errors,
      url,
      method,
      isNetworkError: !status,
    }
  }

  if (typeof error.message === 'string') {
    return { ...fallback, message: error.message }
  }

  return fallback
}
